import { v4 as uuidv4 } from 'uuid';
import { useStorage } from '@vueuse/core';

export const useAdamHeader = () => {
  const { token, refreshToken } = useAdamTokens();
  const runtimeConfig = useRuntimeConfig();
  const nomadInstallId = useStorage('uuid', uuidv4());
  const getAdamHeaders = (): AdamHeaders => {
    const headers: AdamHeaders = new Headers() as AdamHeaders;
    headers['nomad-install-id'] = nomadInstallId.value;
    headers['nomad-eva-2'] = 'true';
    headers['nomad-app-version'] = runtimeConfig.public.appVersion;
    // headers.locale = navigator.language;

    headers.Authorization =
      'Basic YXBwIDViZTU1YTEwNmRhODA4ZGIyMmM1YzNmMDo1dFBWWEtIQVdULzQ2NUprVmJDRw==';
    headers['nomad-timezone'] =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    return headers as AdamHeaders;
  };

  const getAdamAuthHeaders = (): AdamAuthHeaders => {
    const headers: AdamAuthHeaders = {
      ...getAdamHeaders(),
      adammembertoken: toValue(token),
    };
    return headers;
  };

  const getAdamAuthRefreshHeaders = (): AdamAuthRefreshHeaders => {
    const headers: AdamAuthRefreshHeaders = {
      ...getAdamAuthHeaders(),
      adammemberrefreshtoken: toValue(refreshToken),
    };
    return headers;
  };

  return {
    getAdamHeaders,
    getAdamAuthHeaders,
    getAdamAuthRefreshHeaders,
  };
};
